module.exports = __webpack_public_path__ + "img/dianxin5-2.49f0eaf5.jpg";